import { Css } from "@homebound/beam";
import React from "react";
import { SearchBox } from "src/components";
import { TableActions } from "src/routes/layout/TableActions";
import { useProductOfferingStore } from "../ProductOfferingScopeContext";
import { GroupBySelectField } from "./GroupBySelectField";
import { SortBySelectField } from "./SortBySelectField";

export function ProductOfferingScopeTableActionsComponent() {
  const setSearch = useProductOfferingStore((state) => state.setItemTableSearch);

  return (
    <TableActions>
      <div css={Css.fg1.df.aic.gap1.$}>
        <div css={Css.mwPx(140).$}>
          <SearchBox onSearch={setSearch} debounceDelayInMs={200} />
        </div>
        <div>
          <GroupBySelectField />
        </div>
        <div>
          <SortBySelectField />
        </div>
      </div>
    </TableActions>
  );
}

export const ProductOfferingScopeTableActions = React.memo(ProductOfferingScopeTableActionsComponent);
